import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { showModal } from 'actions/modals';

import { TRACKING_BUTTON_TEXTS } from 'features/messengerv2/constants';
import * as constants from 'features/modals/constants';
import UpgradeWrapper from 'features/permissions/UpgradeWrapper';

import Box from 'components/Box';
import Button from 'components/clickables/Button';
import Text from 'components/Text';

import {
  EVENT_ACTIONS,
  EVENT_CATEGORIES,
  TRACK_ACTION_TYPES,
} from 'util/tracking_constants';
import { useTrackUx } from 'util/uxEvents';

const MenuOptions = ({ repackagingEnabled }) => {
  const trackUxEvent = useTrackUx({
    eventCategory: EVENT_CATEGORIES.CHANNEL_LIST,
  });

  const dispatch = useDispatch();

  const handleShowDownloadMessageLogsModal = useCallback(() => {
    dispatch(showModal(constants.DOWNLOAD_MESSAGES_MODAL));
    trackUxEvent(EVENT_ACTIONS.BUTTON_CLICKED, TRACK_ACTION_TYPES.CLICK, {
      buttonText: TRACKING_BUTTON_TEXTS.DOWNLOAD_ALL_MESSAGES,
    });
  }, [trackUxEvent, dispatch]);

  return (
    <Box tleft>
      <Box bt phm pvxs>
        <UpgradeWrapper
          feature="messaging_settings"
          focusedFeature="permissionAndDepartments"
          paywallVersion={
            repackagingEnabled ? 'team_permissions_version' : null
          }
        >
          <Button theme="link" onClick={handleShowDownloadMessageLogsModal}>
            <Text fs12 neutral700 i18n="message_drawer.menu.download" />
          </Button>
        </UpgradeWrapper>
      </Box>
    </Box>
  );
};

MenuOptions.propType = {
  repackagingEnabled: PropTypes.bool.isRequired,
};

export default MenuOptions;
